import classnames from 'classnames';
import { Reveal, Status } from '@stadionhq-v3/base-ui';
import {
  CondensedOnScrollHeader,
  CondensedOnScrollHeaderProps,
} from '@stadionhq-v3/football-ui';
import ReactDOM from 'react-dom';
import {
  getMatchStatus,
  MATCH_STATUS,
  OptaMatchStatus,
} from '@stadionhq-v3/core';
import { Live } from '@components/icons';
import styles from './matchHeaderOnScroll.module.scss';
import { MatchHeaderOnScrollProps } from './matchHeaderOnScroll.types';
import { QA_MATCH_HEADER_ON_SCROLL } from '../../../testConfig/testIds';

const portalRoot =
  typeof document !== 'undefined'
    ? document.getElementById('portal-root')
    : null;

const MatchHeaderOnScroll = ({
  testId = QA_MATCH_HEADER_ON_SCROLL.COMPONENT,
  classNames = [],
  nativeProps = {},
  away,
  home,
  events,
  penalties,
  matchStatus,
  minute,
}: MatchHeaderOnScrollProps) => {
  const classes = classnames([styles.matchHeaderOnScroll], classNames);

  if (!portalRoot) return null;

  const isPrematch = getMatchStatus(matchStatus) === MATCH_STATUS.PRE_MATCH;
  const isLive = getMatchStatus(matchStatus) === MATCH_STATUS.LIVE;

  return ReactDOM.createPortal(
    <div {...nativeProps} className={classes} data-testid={testId}>
      <Reveal
        fadeIn
        direction="down"
        delay={100}
        distance="0px"
        classNames={[classnames([styles.condensedHeaderReveal])]}
      >
        <CondensedOnScrollHeader
          classNames={[classnames([styles.condensedHeader])]}
          away={away as CondensedOnScrollHeaderProps['away']}
          home={home as CondensedOnScrollHeaderProps['home']}
          events={events}
          penalties={penalties}
          matchPeriod={matchStatus as OptaMatchStatus}
          alternativeScoreBox={
            <div className={styles.scoreContainer}>
              <span>{home?.score}</span>

              {minute && !isPrematch && (
                <div className={styles.statusContainer}>
                  <Status
                    icon={isLive ? <Live /> : undefined}
                    title={minute}
                    classNames={[
                      classnames([
                        styles.badge,
                        isLive ? styles.liveBadge : styles.fulltime,
                      ]),
                    ]}
                  />
                </div>
              )}
              <span>{away?.score}</span>
            </div>
          }
        />
      </Reveal>
    </div>,
    portalRoot
  );
};

export default MatchHeaderOnScroll;
